import React, { useState, useEffect } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import cookie from "react-cookies";
import "react-datepicker/dist/react-datepicker.css";
import { VAS_BASE_URL, UNIFIED_BASE_URL, CLIQ_BASE_URL } from "../../webbase";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
const Transaction = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [transactions, setTransactions] = useState([]);
  const [marchantList, setMarchantList] = useState([]);
  const [merchantEmail, setMerchantEmail] = useState("topupbox");
  const [getDealer, setGetDealer] = useState([]);
  const [dealer, setDealer] = useState('');
  const [product, setProduct] = useState('electricity');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const token = cookie.load("token");

  const makeShortDate = (date) => {
    date = new Date(date);
    const yy = date.getFullYear();
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    return `${yy}/${mm < 10 ? "0" : ""}${mm}/${dd < 10 ? "0" : ""}${dd}`;
  };

  const getTransactions = () => {
    const url = `${CLIQ_BASE_URL}/api/v3/w3/mobile-custom-report?endDate=${makeShortDate(endDate).split('/').join('-')}&startDate=${makeShortDate(startDate).split('/').join('-')}&merchantEmail=${merchantEmail}&product=${product}`;

    axios
      .get(url, {
        headers: { authorization: token },
      })
      .then((res) => {
        setTransactions(res.data.data || []);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // const getMerchant = () => {
  //   axios
  //     .post(
  //       `${UNIFIED_BASE_URL}/onboarding/all-merchants`,
  //       {},
  //       {
  //         headers: { authorization: token },
  //       }
  //     )
  //     .then((res) => {
  //       setMarchantList(res.data.data.data || []);
  //     })
  //     .catch((err) => {
  //       console.error(`${UNIFIED_BASE_URL} ${err}`);
  //     });
  // };

  const handleSelectChange = (event) => {
    setMerchantEmail(event.target.value);
  };

  useEffect(() =>{
    const fetchDealerData = async () => {
        try {
          const res = await axios.get(
            `${UNIFIED_BASE_URL}/manage/get-dealer`,
            { headers: { authorization: token } }
          );
    
          if (res.data.status !== "4000") {
            setGetDealer(res.data.data);
          }
        } catch (err) {
          toast.error("Error fetching transactions");
          console.error(err);
        }
      };
    
      fetchDealerData();
  },[token])

  useEffect(() =>{
    const fetchDealerData = async () => {
        try {
          const res = await axios.get(
            `${UNIFIED_BASE_URL}/onboarding/stp-users?dealerId=` + dealer,
            { headers: { authorization: token } }
          );
    
          if (res.data.status !== "4000") {
            setMarchantList(res.data.data.merchants);
          }
        } catch (err) {
          toast.error("Error fetching transactions");
          console.error(err);
        }
      };
    
      fetchDealerData();
  },[token, dealer])

  useEffect(() => {
    getTransactions();
    // getMerchant();
  }, []);

  useEffect(() => {
    getTransactions();
  }, [merchantEmail, startDate, endDate, product]);

  // Get current transactions for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransactions = transactions.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <main className="page-content">
      <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <div className="ps-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0 p-0">
              <li className="breadcrumb-item">
                <a href="#">
                  <i className="bx bx-home-alt"></i>
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Transactions
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-3">
          <div className="row g-3">
            <div className="col-lg-3 col-md-6 me-auto">
              <div className="ms-auto position-relative">
                <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                  <i className="bi bi-search"></i>
                </div>
                <input
                  className="form-control ps-5"
                  type="text"
                  placeholder="Search Payment"
                />
              </div>
            </div>
            <div className=" col-3">
                <Select
                  classNamePrefix="react-select"
                  options={getDealer.map((e) => ({ value: e.dealerId, label: e.businessName, id: e.id }))}
                  value={getDealer.find((e) => e.dealerId === dealer) ? { value: dealer, label: getDealer.find((e) => e.dealerId === dealer)?.businessName } : null}
                  onChange={(selected) => {
                    setDealer(selected ? selected.value : "");
                    setMerchantEmail("");
                  }}
                  placeholder="Select Dealer"
                  isClearable
                />
             </div>
             {dealer && 
              <div className="col-3">
                <Select
                  classNamePrefix="react-select"
                  options={marchantList.map((e) => ({ value: e.businessEmail, label: e.businessEmail, id: e.id }))}
                  value={marchantList.find((e) => e.businessEmail === merchantEmail) ? { value: merchantEmail, label: merchantEmail } : null}
                  onChange={(selected) => setMerchantEmail(selected ? selected.value : "")}
                  placeholder="Select merchant"
                  isClearable
                />
            </div>
             }
           
            <div className="col-lg-2 col-6 col-md-3">
              <select className="form-select" value={product} onChange={(e) => setProduct(e.target.value)}>
                {/* <option value="">All Products</option> */}
                <option value="cable">Cable</option>
                <option value="electricity">Electricity</option>
                <option value="waec">WAEC</option>
                <option value="jamb">JAMB</option>
                <option value="internet">Internet</option>
              </select>
            </div>
          </div>
        </div>
        
        <div className="row m-3">
          <div className="col-3">
            <p className="form-label">From:</p>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
            />
          </div>
          <div className="col-3">
            <p className="form-label">To:</p>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
            />
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table
              id="example"
              className="table table-striped table-bordered"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Customer Ref</th>
                  <th>Business Name</th>
                  <th>Product</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {currentTransactions.map((transaction, index) => (
                  <tr key={index}>
                    <td>{transaction?.customerRef || 'N/A'}</td>
                    <td>{transaction?.businessName || 'N/A'}</td>
                    <td>{transaction?.product || 'N/A'}</td>
                    <td>NGN {transaction?.amount || 0}</td>
                    <td>
                      <span className={`badge ${transaction?.status === 'successfull' ? 'bg-success' : 'bg-danger'}`}>
                        {transaction?.status || 'N/A'}
                      </span>
                    </td>
                    <td>{transaction?.date ? new Date(transaction.date).toLocaleDateString() : 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* Pagination */}
          <div className="d-flex justify-content-end mt-4">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => paginate(currentPage - 1)}>
                    Previous
                  </button>
                </li>
                {Array.from({ length: Math.ceil(transactions.length / itemsPerPage) }, (_, i) => (
                  <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => paginate(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === Math.ceil(transactions.length / itemsPerPage) ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Transaction;
